export const TAB_NAMES = ['users', 'teams', 'lines-of-business', 'invitations', 'devices'];
export const DEFAULT_TAB_NAME = TAB_NAMES[0];

export const STATUS_ACTIVE = 'active';
export const STATUS_PENDING = 'pending';
